exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Users/charles/Projects/codemix/2016/flow-runtime/~/core-js/library/modules/_wks-ext.js
// module id = 87
// module chunks = 0